import React, { Component, createRef } from 'react';
import { Form, Media, Modal } from 'react-bootstrap';
import { Link, withRouter } from "react-router-dom";
import Layout from "../../components/Layout";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from '../../Languages/DE';
import { callAPI } from "../../helper/apiUtils";
import { EN } from '../../Languages/EN';
import { $crud } from "../../helper/CrudFactory";
import { getDroppedFiles, fileFingerprint } from "../../utils/composerUtils";
import { ARTICLE_MEDIA_ACCEPT, isVideoFile } from "../../utils/chatVideo";
import {
    compressArticleVideo,
    mergeArticleVideoMeta,
    postArticleFormData,
    prepareArticleVideoForComposer,
} from "../../utils/articleComposerVideo";
import { compressLocalArticleImages } from "../../utils/compressArticleImage";
import { createPublishProgressTracker, waitUntilArticleVideosReady } from "../../utils/articlePublishProgress";
import ArticlePublishProgress from "../../components/ArticlePublishProgress";
import { ReactComponent as SmilyIcon } from "../../Icons/SmilyDeselected.svg"
import { BASE_URL } from "../../helper/constants";
import Carousel from "react-multi-carousel";
import { Scrollbars } from "react-custom-scrollbars";
import { BsClock } from "react-icons/bs";
import { BsChevronDown } from "react-icons/bs";
import ProjectListDialog from "./Dialogs/ProjectListDialog";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import { stripMarkdownFromTitle } from '../../helper/stripMarkdownTitle';
import { pastedArticleToHtml, insertPastedArticleHtml } from '../../utils/articleEditorPaste';
import { convertBranchRole, convertBuildings, convertHtmlString, urlify } from '../../helper/convertor';
import { formatScheduleDateTime } from '../../helper/dateTimeFormatter';
import { IconButton } from '@material-ui/core';
import PlayerFeed from '../../components/PlayerFeed';
import ReadMores from '../../components/ReadMores';
import DepartLocaDialogue from '../Company/Dialogs/DepartLocaDialogue';
import { connect } from "react-redux";
import RCPlayer from '../../components/RCPlayer';
import TranslationProgressModal from '../../components/TranslationProgressModal';
import ArticleLanguagePicker, { DEFAULT_ARTICLE_LANGUAGE } from "../../components/ArticleLanguagePicker";
import "./CreateCompanyArticle.css";
const extractUrls = require("extract-urls");

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div className="thumb-style" style={{ ...style, ...thumbStyle }} {...props} />;
};

const renderThumbx = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div />;
};

const CustomScrollbars = props => (
    <Scrollbars
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
        renderTrackHorizontal={renderThumbx}
        {...props}
    />
);

class CreateCompanyArticle extends Component {
    static contextType = LanguageContext;

    constructor(props) {
        super(props);
        this.imageInputRef = createRef(null);
        this.formScrollRef = createRef(null);
        this.articleMediaRef = createRef(null);
        this._skipEditorUpdate = false;
        this._lastDropAt = 0;
        this._lastDropCount = 0;
        this.state = {
            buildings: [],
            chars_left: 120,
            article: {
                title: "",
                description: "",
                isEmojiUsed: false,
                uploadType: "",
                file: [],
                link: "",
                buildingId: "",
                product: ""
            },
            // Authoring/source language. Article will not be translated into this language.
            originalLanguage: DEFAULT_ARTICLE_LANGUAGE,
            expand: false,
            preview: false,
            profile: {},
            company: {},
            viewProject: false,
            editorState: "",
            _Link: [],
            departments: [],
            deptLocationId: "",
            isCompanyAdmin: false,
            viewLoader: false,
            modalData: [],
            showPlayer: false,
            initialIndex: 0,
            // Schedule Article States
            showScheduleModal: false,
            scheduleDate: new Date(),
            scheduleTime: new Date(),
            hasUserMadeChanges: false,
            // Discard confirmation modal
            showDiscardConfirm: false,
            // Editor resize state
            editorContentHeight: 150, // Default height in pixels
            isResizing: false,
            // Drag and drop state
            isDragging: false,
            // Inform employees via DM (internal articles only)
            notifyEmployeesViaDm: false,
            // Translation progress
            showTranslationProgress: false,
            translatingArticleId: null,
            videoMeta: {},
            loading: true,
            loadingMode: "initial",
            loadingStep: 1,
            publishProgress: 0,
            publishPhase: "preparing",
        }
    }

    getTransitionSteps = () => {
        const { loadingMode } = this.state;
        const strings = this.context?.strings || {};
        if (loadingMode === "posting") {
            return [
                strings.transition_step_prepare_article || strings.article || "Article",
                strings.transition_step_upload_content || strings.media || "Media",
                strings.transition_step_post_article || strings.post || "Post",
            ];
        }
        return [
            strings.transition_step_open_page || strings.Loading || "Loading...",
            strings.transition_step_prepare_editor || strings.preview || "Preview",
        ];
    };


    getCompanyDetails = async () => {
        this.setState({ loading: true, loadingMode: "initial", loadingStep: 1 })
        const id = this.props?.location?.state?.companyId;
        const { data } = await callAPI(`/company/${id}/profile`, {}, "GET");
        if (data.status) {
            console.log('---data', data)
            this.setState({ company: data.profile })
            if (data.profile.position == "COMPANY ADMIN") {
                this.setState({ isCompanyAdmin: true })
            }
            if (data.profile.position == "COMPANY_DEPARTMENT_ADMIN") {
                this.setState({ deptLocationId: [data.profile.deptLocationId] })
            }
            this.setState({ loadingStep: 2 });
            this._getDepartmentAndLocations()
            // if (this.props?.location?.state?.from == 'internal') {
            //     this._getDepartmentAndLocations()
            // }
            // else {
            //     this.setState({ loading: false })
            // }
        }
        else {
            this.setState({ loading: false })
        }
    };

    _getDepartmentAndLocations = async () => {
        const id = this.props?.location?.state?.companyId;
        const { data } = await callAPI(`/company/getDeptLocation/${id}`, {}, "GET");
        if (data.status) {
            this.setState({ departments: data.data.getCompanyDept })
            this.setState({ loadingStep: 2, loading: false })
        }
        else {
            this.setState({ loading: false })
        }
    }




    toggleSmily = (value) => {
        this.setState({ article: { ...this.state.article, isEmojiUsed: !value } });
    }

    removeImage = (file, index) => {
        const article = this.state.article;
        article.file.forEach(f => {
            if (f.url && f.url.startsWith('blob:')) URL.revokeObjectURL(f.url);
        });
        article.file = [];
        this.setState({ article: article });
    };

    expandArticle = () => {
        this.setState({ expand: true })
    }


    removeAllFields = () => {
        if (this.hasUnsavedArticleContent()) {
            this.setState({ showDiscardConfirm: true });
        } else {
            this.navigateBack();
        }
    }

    hasUnsavedArticleContent = () => {
        const { article, _Link } = this.state;
        const title = (article.title || "").trim();
        const description = String(article.description || "").replace(/<[^>]*>/g, "").trim();
        const hasFiles = (article.file || []).length > 0;
        const hasLinks = (_Link || []).length > 0;
        return !!(title || description || hasFiles || hasLinks);
    }

    confirmDiscardArticle = () => {
        this.setState({
            showDiscardConfirm: false,
            article: {
                title: "",
                description: "",
                isEmojiUsed: false,
                uploadType: "",
                file: [],
                link: "",
                buildingId: "",
                product: "",
            },
            chars_left: 60,
            preview: false
        }, () => {
            this.navigateBack();
        });
    }

    confirmSaveDraftAndLeave = () => {
        this.setState({ showDiscardConfirm: false });
        this.postArticle({ saveAsDraft: true });
    }

    cancelDiscardArticle = () => {
        this.setState({ showDiscardConfirm: false, preview: false });
    }

    navigateBack = () => {
        let fromFeed = this.props?.location?.state?.fromFeeds
        let { hasUserMadeChanges } = this.state
        if (fromFeed && !hasUserMadeChanges) {
            this.props.history.push({
                pathname: '/articles',
                state: { isPosted: false, isExternalSelected: 0 }
            })
        }
        else {
            this.props.history.push({
                pathname: "/cockpit",
                search: `?tab=company&company=${encodeURIComponent(this.props?.location?.state?.companyId || "")}`,
                state: { companyIndex: this.props?.location?.state?.companyIndex, isPosted: true, isExternalSelected: 0 }
            });
        }
    }


    setParam = (key, value) => {
        this.setState(state => {
            return {
                ...state,
                article: {
                    ...state.article,
                    [key]: value
                }
            }
        })
    }


    handleWordCount = async (event) => {
        const maxLen = 120;
        const cleaned = stripMarkdownFromTitle(event.target.value).slice(0, maxLen);
        const charCount = cleaned.length;
        this.setState({
            chars_left: maxLen - charCount
        })
        await this.setParam('title', cleaned)
    }


    get = async () => {

        const { data } = await callAPI('/building/my', {}, 'GET')
        this.setState({
            buildings: data.buildings
        })

        console.log(data)
    }

    componentDidMount() {
        console.log(this.props)
        this.setState({ articleType: this.props?.location?.state?.articleType == 1 ? 1 : 0, companyIndex: this.props?.location?.state?.companyIndex })
        this.get()
        this.getProfile();
        this.getCompanyDetails()


    }

    getProfile = async () => {
        const { data } = await callAPI(`/user/profile`, {}, 'GET')
        console.log(data)
        this.setState({ profile: data.profile })
    }
    // getCompanyDetails = async () => {
    //     const id = this.props.match.params.id
    //     const { data } = await callAPI(`/company/${id}/companyById`, {}, 'GET')
    //     console.log(data)
    //     this.setState({ company: data.company })
    // }


    isPdfFile = (file) => {
        if (!file) return false;
        if (file.type === 'application/pdf') return true;
        const name = file.name || '';
        return /\.pdf$/i.test(name);
    };

    isImageFile = (file) => {
        if (!file) return false;
        return (
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/jpg' ||
            /\.(jpe?g|png)$/i.test(file.name || '')
        );
    };

    static MAX_ARTICLE_FILE_BYTES = 25 * 1024 * 1024;

    isAcceptedArticleFile = (file) => this.isImageFile(file) || this.isPdfFile(file) || isVideoFile(file);

    notifyIfImageOrPdfTooLarge = (files) => {
        const oversized = (files || []).some((f) =>
            f && !isVideoFile(f) && typeof f.size === 'number' && f.size > CreateCompanyArticle.MAX_ARTICLE_FILE_BYTES
        );
        if (!oversized) return false;
        $crud.notify({
            type: 'error',
            message: this.context.strings.max_file_size_exceeded_25mb || 'Max. size of 25MB exceeded. Please choose a smaller file.',
        });
        return true;
    };

    patchArticleVideoMeta = (clientId, patch) => {
        if (!clientId) return;
        this.setState((state) => ({
            videoMeta: {
                ...state.videoMeta,
                [clientId]: { ...(state.videoMeta[clientId] || {}), ...patch },
            },
        }));
    };

    enqueueArticleVideoCompress = (file) => {
        if (!file?.clientId || !file.processing) return;
        this._videoCompressChain = (this._videoCompressChain || Promise.resolve())
            .then(() => this.compressOneArticleVideo(file))
            .catch(() => {});
    };

    compressOneArticleVideo = async (file) => {
        const clientId = file.clientId;
        const compressed = await compressArticleVideo(file, {
            isStale: () => !(this.state.article.file || []).some((f) => f.clientId === clientId),
            onProgress: (pct) => this.patchArticleVideoMeta(clientId, {
                processing: true,
                uploading: false,
                progress: pct,
            }),
        });
        if (!compressed) return;
        await new Promise((resolve) => {
            this.setState((state) => ({
                videoMeta: {
                    ...state.videoMeta,
                    [clientId]: { processing: false, uploading: false, progress: 0 },
                },
                article: {
                    ...state.article,
                    file: (state.article.file || []).map((f) => (f.clientId === clientId ? compressed : f)),
                },
            }), resolve);
        });
    };

    addArticleMediaFiles = async (incoming, { unique = false } = {}) => {
        const list = Array.from(incoming || []);
        const accepted = list.filter(this.isAcceptedArticleFile);
        if (accepted.length === 0) {
            $crud.notify({
                type: 'error',
                message: this.context.strings.unsupported_file_type || 'Unsupported file type. Only images, videos and PDFs are allowed.',
            });
            return;
        }
        const nonVideos = accepted.filter((f) => !isVideoFile(f));
        if (this.notifyIfImageOrPdfTooLarge(nonVideos)) return;

        const previewFiles = [];
        const videosToCompress = [];
        for (const file of accepted) {
            if (isVideoFile(file)) {
                const prepared = await prepareArticleVideoForComposer(file);
                if (!prepared.ok) {
                    $crud.notify({
                        type: 'error',
                        message: this.context.strings[prepared.errorKey] || prepared.errorKey,
                    });
                    continue;
                }
                previewFiles.push(prepared.file);
                if (prepared.needsCompress) videosToCompress.push(prepared.file);
            } else {
                const blobUrl = file.url || URL.createObjectURL(file);
                file.url = blobUrl;
                file.fileUrl = blobUrl;
                file.local = true;
                file.originalName = file.name;
                file.attachedFileName = file.name;
                if (this.isPdfFile(file)) {
                    file.isPdf = true;
                    file.fileType = 'doc';
                } else {
                    file.fileType = 'image';
                }
                previewFiles.push(file);
            }
        }
        if (previewFiles.length === 0) return;

        this.setState((state) => {
            let next = previewFiles;
            if (unique) {
                const existing = new Set((state.article.file || []).map(fileFingerprint));
                next = previewFiles.filter((f) => {
                    const key = fileFingerprint(f);
                    if (existing.has(key)) return false;
                    existing.add(key);
                    return true;
                });
                if (next.length === 0) return null;
            }
            const videoMeta = { ...state.videoMeta };
            next.forEach((f) => {
                if (!f.clientId) return;
                videoMeta[f.clientId] = {
                    processing: !!f.processing,
                    uploading: false,
                    progress: 0,
                };
            });
            return {
                ...state,
                videoMeta,
                article: {
                    ...state.article,
                    file: [...state.article.file, ...next],
                },
            };
        }, () => {
            const present = new Set((this.state.article.file || []).map((f) => f.clientId));
            videosToCompress
                .filter((file) => file.clientId && present.has(file.clientId))
                .forEach((file) => this.enqueueArticleVideoCompress(file));
            this.scrollArticleMediaIntoView();
        });
    };

    scrollArticleMediaIntoView = () => {
        const reveal = () => {
            const media = this.articleMediaRef.current;
            const scroller = this.formScrollRef.current;
            if (!media || !scroller) return;
            const mediaRect = media.getBoundingClientRect();
            const scrollerRect = scroller.getBoundingClientRect();
            const overflowBottom = mediaRect.bottom - scrollerRect.bottom + 12;
            if (overflowBottom > 0) {
                scroller.scrollBy({ top: overflowBottom, behavior: 'smooth' });
            }
        };
        requestAnimationFrame(() => requestAnimationFrame(reveal));
    };

    choseFiles = (e) => {
        this._skipEditorUpdate = true;
        setTimeout(() => { this._skipEditorUpdate = false; }, 500);
        const { files } = e.target;
        if (files.length > 0) {
            this.addArticleMediaFiles(files);
        }
    };
    onInputClick = (event) => {
        event.target.value = "";
    };

    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: true });
    };

    handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.currentTarget && !e.currentTarget.contains(e.relatedTarget)) {
            this.setState({ isDragging: false });
        }
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: false });

        const droppedFiles = getDroppedFiles(e.dataTransfer);
        if (droppedFiles.length === 0) return;

        const now = Date.now();
        if (now - this._lastDropAt < 400 && droppedFiles.length <= this._lastDropCount) return;
        this._lastDropAt = now;
        this._lastDropCount = droppedFiles.length;

        this.addArticleMediaFiles(droppedFiles, { unique: true });
    };

    // Schedule Article Helper Functions
    formatDateTime = (date, time) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(time.getHours()).padStart(2, '0');
        const minutes = String(time.getMinutes()).padStart(2, '0');
        const seconds = '00';
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    formatDateForInput = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    formatDateForDisplay = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}.${month}.${year}`;
    };

    formatTimeForInput = (time) => {
        const hours = String(time.getHours()).padStart(2, '0');
        const minutes = String(time.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    handleScheduleConfirm = () => {
        const { hasUserMadeChanges, scheduleDate, scheduleTime, article } = this.state;

        // Check if user has made any changes
        if (!hasUserMadeChanges) {
            alert(this.context.strings.please_select_different_date_time);
            return;
        }

        // Combine date and time to create scheduled datetime
        const scheduledDateTime = new Date(
            scheduleDate.getFullYear(),
            scheduleDate.getMonth(),
            scheduleDate.getDate(),
            scheduleTime.getHours(),
            scheduleTime.getMinutes(),
            0
        );

        // Get current time
        const now = new Date();

        // Validate that scheduled time is in the future
        if (scheduledDateTime <= now) {
            alert(this.context.strings.please_select_future_date_time);
            return;
        }

        // Close modal and stay on create page
        this.setState({ showScheduleModal: false });
    };

    handlePreview = () => {
        if (!this.state.article.title) {
            $crud.notify({
                type: "error",
                message: this.context.strings.please_enter_article_title,
            });
        }
        else {
            this.setState({ preview: true });
        }
    }

    isArticleFormReady = () => {
        const hasTitle = this.hasArticleTitle();
        const departmentList = Array.isArray(this.state.departments) ? this.state.departments : [];
        const { articleType, deptLocationId } = this.state;
        const hasDeptLoc = articleType != 1
            || departmentList.length === 0
            || (deptLocationId && (Array.isArray(deptLocationId) ? deptLocationId.length > 0 : true));
        return hasTitle && hasDeptLoc;
    }

    hasArticleTitle = () => {
        return !!(this.state.article.title && this.state.article.title.trim().length > 0);
    }

    handleSaveDraft = () => {
        if (!this.hasArticleTitle()) {
            $crud.notify({
                type: "error",
                message: this.context.strings.please_enter_article_title,
            });
            return;
        }
        this.postArticle({ saveAsDraft: true });
    }

    finishArticlePost = (res, { saveAsDraft, articleType, notify } = {}) => {
        if (notify && res && res.message) {
            $crud.notify({
                type: res.status ? "success" : 'error',
                message: res.message
            });
        }
        const companyId = this.props?.location?.state?.companyId;
        if (res.status && res.articleId) {
            this.setState({
                loading: false,
                showTranslationProgress: false,
                translatingArticleId: res.articleId,
                videoMeta: {},
            });
            if (saveAsDraft && companyId) {
                this.props.history.push({ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(companyId)}` });
            } else {
                this.props.history.push({
                    pathname: '/articles',
                    state: { isPosted: false, isExternalSelected: 0, internal: Number(articleType) === 1 }
                });
            }
            return;
        }
        if (!notify) {
            $crud.notify({
                type: res.status ? "success" : 'error',
                message: res.message
            });
        }
        this.setState({ loading: false });
        if (res.status) {
            if (saveAsDraft && companyId) {
                this.props.history.push({ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(companyId)}` });
            } else {
                this.props.history.push({
                    pathname: '/articles',
                    state: { isPosted: false, isExternalSelected: 0, internal: articleType == 1 }
                });
            }
        }
    };

    postArticle = async (options = {}) => {
        if (this.state.loading && this.state.loadingMode === "posting") return;
        const saveAsDraft = !!(options && options.saveAsDraft);
        const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
        const { article, deptLocationId, departments, articleType, hasUserMadeChanges, scheduleDate, scheduleTime } = this.state;
        if (this.notifyIfImageOrPdfTooLarge(article.file)) return;

        this.setState({
            loading: true,
            loadingMode: "posting",
            loadingStep: 1,
            publishProgress: 4,
            publishPhase: "preparing",
        });

        const tracker = createPublishProgressTracker({
            files: article.file,
            onUpdate: ({ phase, percent }) => {
                this.setState({ publishPhase: phase, publishProgress: percent, loadingStep: phase === "finishing" ? 3 : 2 });
            },
        });
        let finishingPulse;

        try {
            if (tracker.hasVideo) {
                tracker.setStage("compressing", 4);
                await waitUntilArticleVideosReady({
                    getChain: () => this._videoCompressChain || Promise.resolve(),
                    getFiles: () => this.state.article.file,
                    getVideoMeta: () => this.state.videoMeta,
                    onProgress: (pct) => tracker.setStage("compressing", pct),
                });
            }

            let files = this.state.article.file || [];
            if (tracker.hasImages) {
                tracker.setStage("media", 2);
                files = await compressLocalArticleImages(files, {
                    onProgress: (pct) => tracker.setStage("media", pct),
                });
            }

            let formData = new FormData();
            formData.append('title', stripMarkdownFromTitle(article.title));
            formData.append('description', article.description ? article.description.replace(regex, (match, p1, p2) => {
                if (p1) return p1;
                return `<a href="${p2}">${p2}</a>`;
            }) : "");
            formData.append('isEmojiUsed', article.isEmojiUsed);
            formData.append('uploadType', (files.length > 0) ? 'media' : 'none');
            formData.append('link', '');
            formData.append('buildingId', article.buildingId);
            formData.append('product', article.product);
            formData.append('articleType', this.state.articleType.toString());
            formData.append(
                'originalLanguage',
                (this.state.originalLanguage || DEFAULT_ARTICLE_LANGUAGE).toLowerCase()
            );

            if (saveAsDraft) {
                formData.append('isPublished', 'false');
            } else {
                const isPublished = hasUserMadeChanges ? false : true;
                formData.append('isPublished', isPublished.toString());
                if (!isPublished && hasUserMadeChanges) {
                    const scheduledDateTime = new Date(
                        scheduleDate.getFullYear(),
                        scheduleDate.getMonth(),
                        scheduleDate.getDate(),
                        scheduleTime.getHours(),
                        scheduleTime.getMinutes(),
                        0
                    );
                    const publishTime = Math.floor(scheduledDateTime.getTime() / 1000);
                    formData.append('publishTime', publishTime.toString());
                }
            }
            if (this.state.articleType.toString() == "1") {
                if (this.props?.location?.state?.deptLocationId || (deptLocationId && deptLocationId.length > 0)) {
                    let ids = deptLocationId ? (Array.isArray(deptLocationId) ? deptLocationId : [deptLocationId]) : [this.props?.location?.state?.deptLocationId];
                    for (let i = 0; i < ids.length; i++) {
                        formData.append(`deptLocation`, ids[i]);
                    }
                } else if (articleType == 0 && departments.length > 0) {
                    for (let i = 0; i < departments.length; i++) {
                        formData.append(`deptLocation`, departments[i].id);
                    }
                }
                formData.append('notifyEmployeesViaDm', String(!!this.state.notifyEmployeesViaDm));
            }
            files.forEach((f) => {
                formData.append('file', f, f.name || f.attachedFileName || f.originalName);
            });

            const localIds = files.filter((f) => f?.clientId && isVideoFile(f)).map((f) => f.clientId);
            if (localIds.length) {
                const nextMeta = { ...this.state.videoMeta };
                localIds.forEach((id) => {
                    nextMeta[id] = { processing: false, uploading: true, progress: 0 };
                });
                this.setState({ videoMeta: nextMeta });
            }

            tracker.setStage("uploading", 2);
            const companyArticleUrl = `/company/${this.props?.location?.state?.companyId}/article`;
            const res = await postArticleFormData(companyArticleUrl, formData, {
                onUploadProgress: (evt) => {
                    if (!evt.total) return;
                    const pct = Math.round((evt.loaded * 100) / evt.total);
                    tracker.setStage("uploading", pct);
                    if (localIds.length) {
                        this.setState((state) => {
                            const videoMetaNext = { ...state.videoMeta };
                            localIds.forEach((id) => {
                                videoMetaNext[id] = {
                                    processing: false,
                                    uploading: true,
                                    progress: pct >= 100 ? 100 : pct,
                                };
                            });
                            return { videoMeta: videoMetaNext };
                        });
                    }
                    if (pct >= 100 && !finishingPulse) {
                        let tick = 12;
                        finishingPulse = setInterval(() => {
                            tick = Math.min(88, tick + 7);
                            tracker.setStage("finishing", tick);
                        }, 350);
                    }
                },
            });
            if (finishingPulse) clearInterval(finishingPulse);
            this.setState({ publishProgress: 100, publishPhase: "finishing", loadingStep: 3 });
            this.finishArticlePost(res || {}, { saveAsDraft, articleType, notify: true });
        } catch (e) {
            if (finishingPulse) clearInterval(finishingPulse);
            $crud.notify({
                type: 'error',
                message: e.message || this.context.strings.article_publish_uploading || 'Uploading…',
            });
            this.setState({ loading: false, publishProgress: 0 });
        }
    }
    handlePastedText = (text, html) => {
        const pastedHtml = pastedArticleToHtml(text, html);
        if (!pastedHtml) return false;
        const nextState = insertPastedArticleHtml(this.state.editorState, pastedHtml);
        if (!nextState) return false;
        this.onEditorStateChange(nextState);
        return true;
    };

    onEditorStateChange = (editorState) => {
        if (this._skipEditorUpdate) {
            this.setState({ editorState });
            return;
        }
        const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
        let currentContentAsHTML = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        const strippedText = currentContentAsHTML.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '').trim();
        if (!strippedText) {
            currentContentAsHTML = '';
        }
        this.setState(state => {
            return {
                ...state,
                article: {
                    ...state.article,
                    description: currentContentAsHTML,
                },
                editorState,
            }
        })
        this.setParam(
            "description",
            convertHtmlString(
                currentContentAsHTML
                    .replace(regex, (match, p1, p2) => {
                        if (p1) {
                            return p1;
                        } else {
                            return `<a href="${p2}">${p2}</a>`;
                        }
                    })
            )
        );
        this._checkForLink(currentContentAsHTML);
    };
    handleResizeStart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const startY = e.clientY;
        const startHeight = this.state.editorContentHeight;
        
        this.setState({ isResizing: true });
        
        const handleMouseMove = (moveEvent) => {
            moveEvent.preventDefault();
            moveEvent.stopPropagation();
            const deltaY = moveEvent.clientY - startY;
            const newHeight = Math.round(startHeight + deltaY);
            const minHeight = 150;
            const maxHeight = 600;
            
            if (newHeight >= minHeight && newHeight <= maxHeight) {
                this.setState({ editorContentHeight: newHeight });
            }
        };
        
        const handleMouseUp = (upEvent) => {
            upEvent.preventDefault();
            this.setState({ isResizing: false });
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }

    _checkForLink = (currentContentAsHTML) => {
        let datax = extractUrls(currentContentAsHTML);
        datax = datax && Array.isArray(datax) ? datax.map(e => { return e.replace('&quot', '') }) : []
        let data = [...new Set(datax)];
        let videoLinks = []
        if (data && data.length > 0) {
            for (let obj of data) {
                let x = { href: obj }
                let lnk = obj
                if (lnk.match('vimeo')) {
                    x.videoType = 'vimeo'
                    videoLinks.push(x)
                }
                if (lnk.match('youtube') || lnk.match('youtu')) {
                    x.videoType = 'youtube'
                    videoLinks.push(x)
                }
            }
        }
        this.setState({ _Link: videoLinks });
    }
    renderImages = (isPreview = false) => {
        const { isGerm, strings } = this.context;
        const files = this.state.article.file;
        if (files?.length === 0) {
            return null;
        }
        return (
            <div
                className={`col-lg-12 p-2 position-relative create-company-article__images${files.length > 2 ? " create-company-article__images--scroll" : ""}`}
            >
                {!isPreview &&
                    <span
                        className="material-symbols-outlined pointer position-absolute remove-image-icon create-company-article__remove-image"
                        onClick={(e) => this.removeImage()}
                        title={this.context.strings.remove_image}
                    >
                        cancel
                    </span>
                }
                {files.map((each) => {
                    return (
                        <img
                            className={files.length >= 2 ? "upload-multi-group-image" : ""}
                            src={each.url}
                            key={each?.name}
                            alt={each?.name}
                        />
                    );
                })}
            </div>
        );
    };
    render() {
        const regex = /(<a[^>]*>.*?<\/a>)|(https?:\/\/[^\s<>\"]+)/g;
        const { _Link, article, articleType, departments, showDepartModal, loading, modalData, initialIndex, showPlayer, hasUserMadeChanges, scheduleDate, scheduleTime, videoMeta } = this.state
        const displayLinks = [..._Link, ...mergeArticleVideoMeta(article.file || [], videoMeta)]
        return (
            <React.Fragment>
                <div className={`following create-company-article${(typeof window !== 'undefined' && window.innerWidth > 1600) ? ' create-company-article--wide' : ''}`}>
                    {loading && this.state.loadingMode === "posting" && (
                        <ArticlePublishProgress
                            percent={this.state.publishProgress}
                            phase={this.state.publishPhase}
                            strings={this.context.strings || {}}
                            isInternal={articleType == 1}
                        />
                    )}
                    {loading && this.state.loadingMode !== "posting" && (
                        <div className="article-transition-screen">
                            <div className="article-transition-card">
                                {this.getTransitionSteps().map((stepLabel, index) => {
                                    const isDone = this.state.loadingStep > index + 1;
                                    const isActive = this.state.loadingStep === index + 1;
                                    return (
                                        <div
                                            key={stepLabel}
                                            className={`article-transition-step ${isActive ? "article-transition-step-active" : ""}`}
                                        >
                                            <span className="article-transition-step-icon">
                                                {isDone ? (
                                                    <span className="material-symbols-outlined article-transition-check">check_circle</span>
                                                ) : (
                                                    <span className={`article-transition-step-number ${isActive ? "article-transition-step-number-active" : ""}`}>
                                                        {index + 1}
                                                    </span>
                                                )}
                                            </span>
                                            <span>{stepLabel}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {!this.state.preview ?
                        <div className={`${articleType == 1 ? "main_heading main_heading-internal" : "main_heading"} create-company-article__header`}>
                            <div className="create-company-article__header-left">
                                {/* Legacy image removed */}
                            </div>
                            <button
                                type="button"
                                onClick={() => this.removeAllFields()}
                                className={`kj-btn kj-btn--icon kj-btn--neutral${articleType == 1 ? ' kj-btn--internal' : ''} create-company-article__btn-gap`}
                                data-article-type={articleType}>
                                <span className="material-symbols-outlined close-icon">close</span>
                            </button>
                        </div>
                        :
                        <></>
                    }

                    {this.state.preview ?
                        <div className="create-company-article__preview-scroll">
                            {
                                this.state.preview &&
                                <div>
                                    <div className="article-live-preview">
                                        <Media className="article-author-media">
                                            {
                                                this.props?.location?.state?.from != 'internal' ? (
                                                    <img
                                                        width={40}
                                                        height={40}
                                                        className="mr-3 news_profile create-company-article__author-img"
                                                        src={this.state.company.logo ? BASE_URL + this.state.company.logo : this.state.company.avatar ? BASE_URL + this.state.company.avatar : process.env.PUBLIC_URL + "/assets/img/Companies-No-Image.svg"}
                                                        alt="Generic placeholder"
                                                    />
                                                ) : (
                                                    <img
                                                        width={25}
                                                        height={25}
                                                        className="mr-3 news_profile create-company-article__author-img create-company-article__author-img--round"
                                                        src={
                                                            this.state.article.postedByImage ? BASE_URL + this.state.article.postedByImage :
                                                            this.state.article.userAvatar ? BASE_URL + this.state.article.userAvatar :
                                                            this.state.article.userImage ? BASE_URL + this.state.article.userImage :
                                                            this.state.article.userProfileImage ? BASE_URL + this.state.article.userProfileImage :
                                                            this.props.user.avatar ? BASE_URL + this.props.user.avatar :
                                                            process.env.PUBLIC_URL + "assets/img/head.svg"
                                                        }
                                                        alt="Generic placeholder"
                                                    />
                                                )
                                            }

                                            <Media.Body>
                                                {this.props?.location?.state?.from != 'internal' ? (
                                                    <>
                                                        <div className="authore_name">
                                                            <h5>{this.state.company.companyName}</h5>
                                                        </div>
                                                        <div className="w-100">
                                                            <h6>
                                                                <span className="text-73 create-company-article__author-name">{this.state.profile.fullName}</span>
                                                                {this.props.user.buildingIndustryRole && (
                                                                    <>
                                                                        {' '}-<span> {convertBranchRole(this.props.user.buildingIndustryRole, this.context.isGerm)}</span>
                                                                    </>
                                                                )}
                                                            </h6>
                                                            <div className="w-100">
                                                                {
                                                                    this.state.article.product ?
                                                                        <h6 className="product_user">Product: <span>{this.state.article.product}</span></h6> : ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="authore_name internal-article-author">
                                                        <h5>
                                                            <span className="internal-article-name">{this.props.user.firstName + " " + this.props.user.lastName}</span>
                                                            {this.props.user.buildingIndustryRole && (
                                                                <span className="internal-article-branch" data-tooltip={convertBranchRole(this.props.user.buildingIndustryRole, this.context.isGerm)}>- {convertBranchRole(this.props.user.buildingIndustryRole, this.context.isGerm)}</span>
                                                            )}
                                                        </h5>
                                                    </div>
                                                )}
                                            </Media.Body>
                                        </Media>
                                        <strong className="mb-2 mt-2 d-block create-company-article__preview-title">{stripMarkdownFromTitle(this.state.article.title || '')}</strong>

                                        <div className="small create-company-article__preview-desc">
                                            <ReadMores isInternal={articleType == 1}>
                                                {this.state.article?.description.replace(regex, (match, p1, p2) => {
                                                    // p1 will contain the matched <a> tag if it exists
                                                    // p2 will contain the URL if it exists
                                                    if (p1) {
                                                        // If <a> tag exists, return it as it is
                                                        return p1;
                                                    } else {
                                                        // If not, wrap the URL in <a> tag
                                                        return `<a href="${p2}">${p2}</a>`;
                                                    }
                                                })}
                                            </ReadMores>
                                        </div>


                                    </div>
                                    <PlayerFeed
                                        Links={displayLinks}
                                        article={article}
                                        isC={true}
                                        prev={true}
                                        isInternal={articleType == 1}
                                        onPress={(data, index) => {
                                            this.setState({ showPlayer: true, modalData: data, initialIndex: index })
                                        }}
                                    />
                                    {/* Schedule Note - Show below description when article is scheduled */}
                                    {hasUserMadeChanges && scheduleDate && scheduleTime && (
                                        <div 
                                            className={`schedule-note-card ${articleType == 1 ? 'schedule-note-card-internal' : 'schedule-note-card-external'}`}
                                            onClick={() => this.setState({ showScheduleModal: true })}>
                                            <div className={`schedule-note-icon-wrapper ${articleType == 1 ? 'schedule-note-icon-wrapper-internal' : 'schedule-note-icon-wrapper-external'}`}>
                                                <span className={`material-symbols-outlined schedule-note-icon ${articleType == 1 ? 'schedule-note-icon-internal' : 'schedule-note-icon-external'}`}>
                                                    schedule
                                                </span>
                                            </div>
                                            <div className="schedule-note-content">
                                                <p className="schedule-note-label">
                                                    {this.context.strings.scheduled_for_publication}
                                                </p>
                                                <p className="schedule-note-datetime">
                                                    {formatScheduleDateTime(scheduleDate, scheduleTime, this.context.language || (this.context.isGerm ? 'de' : 'en'), this.context.strings?.at_time)}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                        :
                        <div ref={this.formScrollRef} className="article-form-scroll-container create-company-article__form-scroll">
                            {
                                !this.state.preview &&
                                <div>

                                    <div className="article_form">
                                        <div className="form-bottom">
                                            <Form className="add_company_from">
                                                <Form.Group controlId="formBasicEmail">
                                                    <Form.Control type="text"
                                                        className={`form-control article-title-input ${articleType == 0 ? 'article-title-input-external' : ''}`}
                                                        rows={1}
                                                        maxLength="120"
                                                        value={this.state.article.title}
                                                        onChange={this.handleWordCount}
                                                        placeholder={this.context.strings.title}
                                                        data-article-type={articleType}
                                                    />
                                                    <Form.Text
                                                        className="text-muted"> {this.state.chars_left} {this.context.strings.characters_remaining}</Form.Text>
                                                </Form.Group>

                                                <Form.Group controlId="formBasic">
                                                    <div className="d-flex">
                                                        <div className="create-company-article__editor-col">
                                                            <div className="resizable-editor-container">
                                                                <Editor
                                                                    stripPastedStyles={true}
                                                                    editorState={this.state.editorState}
                                                                    toolbar={{
                                                                        options: ["inline", "list"],
                                                                        inline: {
                                                                            inDropdown: false,
                                                                            options: ["bold", "italic", "underline"],
                                                                        },
                                                                        list: {
                                                                            inDropdown: false,
                                                                            options: ["unordered", "ordered"]
                                                                        },
                                                                    }}
                                                                    editorClassName="demo-editor"
                                                                    toolbarStyle={{
                                                                        border: 'none'
                                                                    }}
                                                                    wrapperStyle={{
                                                                        border: 'none'
                                                                    }}
                                                                    editorStyle={{
                                                                        border: 'none',
                                                                        fontSize: "var(--kjuup-type-body)",
                                                                        color: '#737373',
                                                                        minHeight: this.state.editorContentHeight + 'px',
                                                                        height: this.state.editorContentHeight + 'px',
                                                                        overflowY: 'auto',
                                                                        overflowX: 'hidden',
                                                                        position: 'relative'
                                                                    }}
                                                                    toolbarClassName={this.props?.location?.state?.articleType == 1 ? "toolbar-class custom-richtext-internal" : "toolbar-class custom-richtext"}
                                                                    onEditorStateChange={this.onEditorStateChange}
                                                                    handlePastedText={this.handlePastedText}
                                                                    placeholder={this.state.editorState && typeof this.state.editorState.getCurrentContent === 'function' && this.state.editorState.getCurrentContent().getBlockMap().some(block => ['unordered-list-item', 'ordered-list-item'].includes(block.getType())) ? '' : this.context.strings.text}
                                                                />
                                                                <div
                                                                    className="editor-resize-handle create-company-article__resize-handle"
                                                                    onMouseDown={this.handleResizeStart}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div style={{ position: "absolute", right: 0, }}>
                                                            <div className="form-icons" style={{ marginRight: 20, marginTop: 3 }}>
                                                                <SmilyIcon
                                                                    className={this.state.article.isEmojiUsed ? articleType == 1 ? 'smily-icon-internal active' : 'smily-icon active' : 'smily-icon'}
                                                                    onClick={e => this.toggleSmily(this.state.article.isEmojiUsed)}
                                                                    width={20} />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </Form.Group>
                                                <Form.Group controlId="articleOriginalLanguage" className="select_coustom">
                                                    <Form.Label className="d-block mb-1 create-company-article__lang-label">
                                                        {this.context.strings.article_original_language}
                                                    </Form.Label>
                                                    <ArticleLanguagePicker
                                                        id="articleOriginalLanguage"
                                                        value={this.state.originalLanguage}
                                                        onChange={(code) => this.setState({ originalLanguage: code })}
                                                    />
                                                    <Form.Text className="text-muted create-company-article__lang-hint">
                                                        {this.context.strings.article_original_language_info}
                                                    </Form.Text>
                                                </Form.Group>
                                                {(departments && departments.length > 0 && this.state.isCompanyAdmin && articleType == 1) ?
                                                    <Form.Group className="select_coustom border-0 hello">
                                                        <a
                                                            className="register_role pointer text-truncate position-relative"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.setState({ showDepartModal: true })
                                                                // setShowDepartModal(true);
                                                            }}
                                                        >
                                                            {!this.state.names && (
                                                                <span className="create-company-article__dep-label">
                                                                    {this.context.strings.dep_loc}{" "}
                                                                </span>
                                                            )}
                                                            {this.state.names && <span className="create-company-article__dep-label">{this.state.names}</span>}
                                                            <BsChevronDown />
                                                        </a>

                                                    </Form.Group>
                                                    :
                                                    <></>
                                                }
                                                {articleType == 1 && (
                                                    <Form.Group className="border-0 mt-2 mb-1 text-left">
                                                        <div
                                                            className={`article-notify-dm ${this.state.notifyEmployeesViaDm ? 'is-selected' : ''}`}
                                                            onClick={() => this.setState({ notifyEmployeesViaDm: !this.state.notifyEmployeesViaDm })}
                                                        >
                                                            <span className="article-notify-dm-check" aria-hidden="true" />
                                                            <span className="article-notify-dm-copy">
                                                                <span className="article-notify-dm-label">
                                                                    {this.context.strings.notify_employees_via_dm
                                                                        || "Inform employees via direct message"}
                                                                </span>
                                                                <span className="article-notify-dm-hint">
                                                                    {this.context.strings.notify_employees_via_dm_hint
                                                                        || "Sends a chat message from your account to employees of the selected departments, locations or teams when the article is published."}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </Form.Group>
                                                )}
                                                <input
                                                    type="file"
                                                    className="d-none"
                                                    multiple
                                                    onChange={this.choseFiles}
                                                    onClick={this.onInputClick}
                                                    accept={ARTICLE_MEDIA_ACCEPT}
                                                    ref={this.imageInputRef}
                                                />
                                                <div ref={this.articleMediaRef}>
                                                <div
                                                    onClick={() => this.imageInputRef.current.click()}
                                                    onDragOver={this.handleDragOver}
                                                    onDragEnter={this.handleDragEnter}
                                                    onDragLeave={this.handleDragLeave}
                                                    onDrop={this.handleDrop}
                                                    className={`article-image-dropzone${this.state.isDragging ? ' article-image-dropzone-active' : ''} create-company-article__dropzone${this.state.isDragging ? ' create-company-article__dropzone--dragging' : ''}${hasUserMadeChanges && scheduleDate && scheduleTime ? ' create-company-article__dropzone--scheduled' : ''}`}>
                                                    <span 
                                                        className="material-symbols-outlined form-add-icon create-company-article__dropzone-icon"
                                                        data-article-type={articleType}
                                                    >{this.state.isDragging ? 'file_download' : 'add_circle'}</span>
                                                    <span className="create-company-article__dropzone-label">
                                                        {this.state.isDragging
                                                            ? (this.context.strings.drop_files_here || this.context.strings.drop_images_here || "Drop files here")
                                                            : (this.context.strings.add_images_or_pdf || this.context.strings.add_images)}
                                                    </span>
                                                    <span className="create-company-article__dropzone-hint">
                                                        {this.context.strings.drag_and_drop_hint_pdf || this.context.strings.drag_and_drop_hint || "or drag & drop images or PDFs here"}
                                                    </span>
                                                </div>
                                                {/* {_Link && _Link.length > 0 && */}
                                                <PlayerFeed
                                                    Links={displayLinks}
                                                    article={article}
                                                    isC
                                                    isInternal={articleType == 1}
                                                    removeImage={(i) => {
                                                        let { article, videoMeta } = this.state
                                                        let ind = article.file.findIndex(e => e.name == displayLinks[i].name)
                                                        if (displayLinks[i]?.clientId) {
                                                            ind = article.file.findIndex(e => e.clientId == displayLinks[i].clientId)
                                                        }
                                                        if (ind !== -1) {
                                                            const removed = article.file[ind];
                                                            if (removed?.url?.startsWith('blob:')) URL.revokeObjectURL(removed.url);
                                                            let x = { ...article }
                                                            let b = [...x.file]
                                                            b.splice(ind, 1)
                                                            x = { ...x, file: b }
                                                            const nextMeta = { ...videoMeta };
                                                            if (removed?.clientId) delete nextMeta[removed.clientId];
                                                            this.setState({ article: x, videoMeta: nextMeta })
                                                        }
                                                    }}
                                                />
                                                </div>
                                                {/* } */}

                                                {/* Scheduled Note - Show at bottom when user has made changes */}
                                                {hasUserMadeChanges && scheduleDate && scheduleTime && (
                                                    <div 
                                                        className={`schedule-note-card ${articleType == 1 ? 'schedule-note-card-internal' : 'schedule-note-card-external'}`}
                                                        onClick={() => this.setState({ showScheduleModal: true })}>
                                                        <div className={`schedule-note-icon-wrapper ${articleType == 1 ? 'schedule-note-icon-wrapper-internal' : 'schedule-note-icon-wrapper-external'}`}>
                                                            <span className={`material-symbols-outlined schedule-note-icon ${articleType == 1 ? 'schedule-note-icon-internal' : 'schedule-note-icon-external'}`}>
                                                                schedule
                                                            </span>
                                                        </div>
                                                        <div className="schedule-note-content">
                                                            <p className="schedule-note-label">
                                                                {this.context.strings.scheduled_for_publication}
                                                            </p>
                                                            <p className="schedule-note-datetime">
                                                                {formatScheduleDateTime(scheduleDate, scheduleTime, this.context.language || (this.context.isGerm ? 'de' : 'en'), this.context.strings?.at_time)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {this.state.preview ?
                        <div className={`row justify-content-between m-0 p-2 button-group-3 preview-mode ${articleType == 1 ? 'preview-mode-internal' : ''}`}>
                            <button type="button" className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                onClick={() => this.setState({ preview: false })}>{this.context.strings.back}</button>
                            <button type="button" className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                disabled={loading}
                                onClick={this.handleSaveDraft}>
                                {this.context.strings.save_as_draft || "Save as Draft"}
                            </button>
                            <button type="button" className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                disabled={loading}
                                onClick={() => {
                                    if (this.state.isCompanyAdmin && this.state.departments.length > 0 && articleType == 1) {
                                        if (!this.state.deptLocationId) {
                                            $crud.notify({
                                                type: 'error',
                                                message: this.context.strings.please_select_department
                                            })
                                        }
                                        else
                                            this.postArticle()
                                    }
                                    else if (!this.state.isCompanyAdmin || this.props?.location?.state?.from != 'internal') {
                                        this.postArticle()
                                    }
                                    else {
                                        this.postArticle()
                                    }
                                }}>
                                {this.state.hasUserMadeChanges
                                    ? (this.context.strings.schedule)
                                    : (this.context.strings.post)
                                }</button>
                        </div>
                        :
                        <></>
                    }
                    {!this.state.preview ?
                        <div className="button-group-3">
                            <button
                                type="button"
                                className={`kj-btn kj-btn--icon kj-btn--neutral schedule-icon-btn${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                onClick={() => this.setState({ showScheduleModal: true })}>
                                <BsClock
                                    size={20}
                                    color={hasUserMadeChanges
                                        ? (articleType == 1 ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)')
                                        : '#999'
                                    }
                                />
                            </button>
                            {(() => {
                                const canSaveDraft = this.hasArticleTitle() && !loading;
                                const isActive = this.isArticleFormReady() && !loading;
                                
                                return (
                                    <>
                                        {canSaveDraft ? (
                                            <button
                                                className="kj-btn kj-btn--secondary article-save-draft-btn"
                                                onClick={this.handleSaveDraft}
                                                type="button"
                                            >
                                                {this.context.strings.save_as_draft || "Save as Draft"}
                                            </button>
                                        ) : (
                                            <button
                                                disabled
                                                className="kj-btn kj-btn--outline create-company-article__btn-gap"
                                                type="button"
                                            >
                                                {this.context.strings.save_as_draft || "Save as Draft"}
                                            </button>
                                        )}
                                        {isActive ? (
                                    <button
                                        className={`kj-btn kj-btn--primary${articleType == 1 ? ' kj-btn--internal' : ''} create-company-article__btn-gap`}
                                        onClick={this.handlePreview}
                                        type="button"
                                    >
                                        {this.context.strings.preview}
                                    </button>
                                ) : (
                                    <button
                                        disabled
                                        className="kj-btn kj-btn--outline create-company-article__btn-gap"
                                        type="button"
                                    >
                                        {this.context.strings.preview}
                                    </button>
                                )}
                                    </>
                                );
                            })()}
                        </div>
                        :
                        <></>
                    }
                    {showDepartModal && (
                        <div className="backdrop create-company-article__depart-backdrop">
                            <DepartLocaDialogue
                                articleType={articleType}
                                handleClose={(e) => this.setState({ showDepartModal: false })}
                                positions={departments.map(dept => ({
                                    ...dept,
                                    isSelected: this.state.deptLocationId && Array.isArray(this.state.deptLocationId) 
                                        ? this.state.deptLocationId.includes(dept.id)
                                        : this.state.deptLocationId == dept.id
                                }))}
                                multiple
                                onSelectMultiple={(ids, names) => {
                                    this.setState({ deptLocationId: ids, names })
                                }}
                            />
                        </div>
                    )}

                </div>
                {
                    this.state.viewProject &&
                    <ProjectListDialog isIntenal={this.props?.location?.state?.articleType == 1 ? true : false} handleClose={() => this.setState({ viewProject: false })}
                        setParam={this.setParam} buildings={this.state.buildings} />
                }


                {/* Schedule Article Modal */}
                {this.state.showScheduleModal && (
                    <div className="schedule-modal-backdrop">
                        <div className="schedule-modal-container">
                            {/* Modal Header */}
                            <div className="schedule-modal-header">
                                <h5 className="schedule-modal-title">
                                    {this.context.strings.schedule_article_post}
                                </h5>
                                <button
                                    type="button"
                                    className="kj-btn kj-btn--icon kj-btn--neutral kj-btn--round"
                                    onClick={() => {
                                        this.setState({
                                            showScheduleModal: false
                                        });
                                    }}>
                                    <span className="material-symbols-outlined create-company-article__schedule-close-icon">close</span>
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="schedule-modal-body">
                                {/* Date Input */}
                                <div className="schedule-form-group">
                                    <label className="schedule-form-label">
                                        {this.context.strings.date}
                                    </label>
                                    <input
                                        type="date"
                                        className="schedule-form-input"
                                        value={this.formatDateForInput(this.state.scheduleDate)}
                                        min={this.formatDateForInput(new Date())}
                                        onChange={(e) => {
                                            const newDate = new Date(e.target.value);
                                            this.setState({
                                                scheduleDate: newDate,
                                                hasUserMadeChanges: true
                                            });
                                        }}
                                    />
                                </div>

                                {/* Time Input */}
                                <div className="schedule-form-group">
                                    <label className="schedule-form-label">
                                        {this.context.strings.time}
                                    </label>
                                    <input
                                        type="time"
                                        className="time-input-no-icon schedule-form-input"
                                        value={this.formatTimeForInput(this.state.scheduleTime)}
                                        onChange={(e) => {
                                            const [hours, minutes] = e.target.value.split(':');
                                            const newTime = new Date(this.state.scheduleTime);
                                            newTime.setHours(parseInt(hours), parseInt(minutes), 0);

                                            // Real-time validation: Check if selected date-time is in the future
                                            const combinedDateTime = new Date(
                                                this.state.scheduleDate.getFullYear(),
                                                this.state.scheduleDate.getMonth(),
                                                this.state.scheduleDate.getDate(),
                                                parseInt(hours),
                                                parseInt(minutes),
                                                0
                                            );

                                            const now = new Date();

                                            // Check if selected date is today
                                            const isToday = this.state.scheduleDate.toDateString() === now.toDateString();

                                            // Only validate time if the date is today
                                            if (isToday && combinedDateTime <= now) {
                                                alert(this.context.strings.please_select_later_time);
                                                return;
                                            }

                                            this.setState({
                                                scheduleTime: newTime,
                                                hasUserMadeChanges: true
                                            });
                                        }}
                                    />
                                </div>

                                {/* Reset Button - Only show when changes made */}
                                {this.state.hasUserMadeChanges && (
                                    <button
                                        type="button"
                                        className={`kj-btn kj-btn--outline kj-btn--sm kj-btn--block schedule-reset-btn${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                        onClick={() => {
                                            this.setState({
                                                scheduleDate: new Date(),
                                                scheduleTime: new Date(),
                                                hasUserMadeChanges: false
                                            });
                                        }}>
                                        ↻ {this.context.strings.reset_selection}
                                    </button>
                                )}
                            </div>

                            {/* Modal Footer */}
                            <div className="schedule-modal-footer">
                                <button
                                    type="button"
                                    className="kj-btn kj-btn--secondary create-company-article__btn-gap"
                                    onClick={() => {
                                        this.setState({
                                            showScheduleModal: false
                                        });
                                    }}>
                                    {this.context.strings.cancel}
                                </button>
                                {this.state.hasUserMadeChanges ? (
                                    <button
                                        type="button"
                                        className={`kj-btn kj-btn--primary${articleType == 1 ? ' kj-btn--internal' : ''}`}
                                        onClick={this.handleScheduleConfirm}>
                                        {this.context.strings.continue}
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        disabled
                                        className="kj-btn kj-btn--outline">
                                        {this.context.strings.continue}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Discard Article Confirmation Modal */}
                <Modal
                    show={this.state.showDiscardConfirm}
                    onHide={this.cancelDiscardArticle}
                    animation={false}
                    centered
                >
                    <Modal.Header
                        className="article-draft-modal-header"
                        closeButton={false}
                    >
                        <button
                            type="button"
                            className="kj-btn kj-btn--icon kj-btn--neutral article-draft-modal-close"
                            onClick={this.cancelDiscardArticle}
                            title={this.context.strings.close || "Close"}
                            aria-label={this.context.strings.close || "Close"}
                        >
                            ×
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-body-relative">
                        <p>{this.context.strings.save_article_as_draft_confirm
                            || "Do you want to save this article as a draft?"}</p>
                    </Modal.Body>
                    <Modal.Footer 
                        className={`${articleType == 1 ? "internal-article-footer" : ""} create-company-article__discard-footer`}
                    >
                        <button
                            type="button"
                            className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                            onClick={this.confirmDiscardArticle}
                        >
                            {this.context.strings.email_discard || this.context.strings.no || "Discard"}
                        </button>
                        <button
                            type="button"
                            className={`kj-btn kj-btn--outline${articleType == 1 ? ' kj-btn--internal' : ''}`}
                            onClick={this.confirmSaveDraftAndLeave}
                        >
                            {this.context.strings.save_as_draft || "Save as Draft"}
                        </button>
                    </Modal.Footer>
                </Modal>

                <TranslationProgressModal
                    show={this.state.showTranslationProgress}
                    articleId={this.state.translatingArticleId}
                    strings={this.context.strings}
                    onComplete={() => {
                        this.setState({ showTranslationProgress: false });
                        const articleType = this.state.articleType;
                        this.props.history.push({
                            pathname: '/articles',
                            state: { isPosted: false, isExternalSelected: 0, internal: articleType == 1 }
                        });
                    }}
                />
            </React.Fragment>
        );
    }
}

// export default withRouter(CreateCompanyArticle);
const mapStateToProps = (state) => {
    const { article, drawerOpen, isExternalSelected, selectedCompanyId, user, isDeskTopResolution } = state;
    return {
        article: article,
        drawerOpen: drawerOpen,
        isExternalSelected,
        selectedCompanyId,
        user: user,
        isDeskTopResolution: isDeskTopResolution
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CreateCompanyArticle));
